import { DownOutlined, FolderOpenTwoTone, LoadingOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Row, Spin, Table, Tree } from 'antd';
import Column from 'antd/es/table/Column';
import type { DataNode } from 'antd/es/tree';
import { Tabs } from 'antd/lib';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idQuyDauTu } from '../../constants';
import { DanhSachNhanVienDuocYKien } from '../../models/donnghiphep/DonNghiPhep';
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import { layDanhSachNguoiYKien, layDanhSachNhanVienTheoNguoiYKien, luuDsNhanVienYKien } from '../../services/donnghiphep';
import { layDsNhanVienTheoDonViTree } from '../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev="" />;

const convertNhanVienTreeView = (data: any) => {
    let nhanVienArr: Array<DataNode> = [];
    if (data) {
        nhanVienArr = data.map((_item: any) => {
            let rs: DataNode = {
                key: "0" + _item?.id,
                title: _item?.hoTen + " - " + _item?.tenChucVu
            }
            return rs;
        })
    }
    return nhanVienArr;
}

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {
                key: _item?.id,
                title: _item?.ten,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
                children: [...convertNhanVienTreeView(_item?.nhanViens), ...convertDataTreeView(_item?.children)]
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const CauHinhNguoiYKien = () => {
    const [nguoiYKienSelected, setNguoiYKienSelected] = useState<any>();
    const [openModalSave, setOpenModalSave] = useState<boolean>(false);
    const [loadingTree, setLoadingTree] = useState<boolean>(false);
    const [allSelectedKeys, setAllSelectedKeys] = useState<Array<any>>([]);
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);
    const [nhanViens, setNhanViens] = useState<any>([]);
    const [allDonViKeys, setAllDonViKeys] = useState<any>([]);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [dataTable, setDataTable] = useState<Array<NhanVienResponse>>([]);
    const dispatch = useDispatch();

    const onCheckTree = (checkedKeysValue: any) => {
        setAllSelectedKeys(checkedKeysValue);
    }; 

    const onSave = async () => {
        dispatch(showLoadingScreen());
        var list = [];
        for (var i = 0; i < allSelectedKeys.length; i++) {
            if (!allDonViKeys.includes(allSelectedKeys[i])) {
                list.push(parseInt(allSelectedKeys[i]));
            }
        }
        var request: DanhSachNhanVienDuocYKien = {
            idNhanVienYKien: nguoiYKienSelected.id,
            idNhanViens: list
        }
        var rs = await luuDsNhanVienYKien(request);
        if (rs) {
            toast.success('Cập nhật danh sách nhân viên cho người ý kiến thành công')
        }
        else {
            toast.error('Cập nhật danh sách nhân viên cho người ý kiến không thành công')
        }
        dispatch(hideLoadingScreen());
    }

    const layDsNguoiYKien = async () => {
        try {
            setIsLoadingTable(true);
            let temp = await layDanhSachNguoiYKien();
            var data = temp.map((item: any) => { item.key = item.id; return item });
            setDataTable(data);
        } catch (error: any) {
            toast.error(error);
        };
        setIsLoadingTable(false);
    }

    const layDsNvTheoDonVi = async () => {
        try {
            setLoadingTree(true);
            let data = await layDsNhanVienTheoDonViTree();
            let idDonVis = data.flatMap(({ id, children }) => [id, ...children?.map(({ id }) => id) || []]);
            setAllDonViKeys(idDonVis);
            setNhanViens(data);
        } catch (error: any) {
            toast.error(error);
        };
        setLoadingTree(false);
    }

    const layDsNvTheoNguoiYKien = async () => {
        if (!nguoiYKienSelected?.key) {
            setAllSelectedKeys([idQuyDauTu]);
            return;
        }
        setLoadingTree(true);
        try {
            let fOU = await layDanhSachNhanVienTheoNguoiYKien(nguoiYKienSelected.id);
            var data = fOU.map((item: any) => { item.key = "0" + item.idNhanVien; return item });
            setAllSelectedKeys([...data.map(x => x.key)]);
        } catch (ex: any) {
            toast.error(ex);
        }

        setLoadingTree(false);
    }

    useEffect(() => {
        const NVTree = convertDataTreeView(nhanViens);
        setTreeData(NVTree);
    }, [nhanViens]);

    useEffect(() => {
        layDsNvTheoDonVi();
        layDsNguoiYKien();
    }, []);
    useEffect(() => {
        layDsNvTheoNguoiYKien();
    }, [nguoiYKienSelected]);

    return (
        <section>
            <ModalTextForm
                show={openModalSave}
                title="Danh sách ý kiến nhân viên"
                handleClose={() => setOpenModalSave(false)}
                handleSave={async () => {
                    await onSave()
                    setOpenModalSave(false)
                }}
            >
                <p>Bạn có xác nhận lưu không?</p>
            </ModalTextForm>
            <ContentHeader title="Cấu hình người ý kiến đơn xin phép/Thêm giờ" />
            <Row gutter={16}>
                <Col span={12}>
                    <Tabs defaultActiveKey="1"
                        items={[{
                            key: '1',
                            label: 'Danh sách người ý kiến',
                            children:
                                <div className="card">
                                    <div className="card-primary">
                                        <Table
                                            dataSource={dataTable}
                                            loading={isLoadingTable}
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            rowKey="id"
                                            onRow={(record, rowIndex) => {
                                                return {
                                                    onClick: event => {
                                                        if (record?.id === nguoiYKienSelected?.id) {
                                                            setNguoiYKienSelected(null);
                                                        } else {
                                                            setNguoiYKienSelected(record);
                                                        }
                                                    },
                                                };
                                            }}
                                            rowClassName={(record, index) => {
                                                return (record?.id === nguoiYKienSelected?.id) ? "selected-row row-key-" : "";
                                            }}
                                        >
                                            <Column title="Tên nhân sự" width="34%" dataIndex="hoTen" key="hoTen" />
                                            <Column title="Phòng ban" width="33%" dataIndex="tenDonVi" key="tenDonVi" />
                                            <Column title="Chức vụ" width="33%" dataIndex="tenChucVu" key="tenChucVu" />
                                        </Table>
                                    </div>
                                </div>
                        }]}>
                    </Tabs>
                </Col>
                <Col span={12}>
                    <Tabs defaultActiveKey="1"
                        tabBarExtraContent=
                        {
                            nguoiYKienSelected?.id ?
                                <Button
                                    type="primary"
                                    icon={<SaveOutlined rev="" />}
                                    onClick={() => setOpenModalSave(true)}
                                > Lưu
                                </Button> : <></>
                        }
                        items={[{
                            key: '1',
                            label: 'Danh sách nhân sự',
                            children:
                                <div className="card card-body">
                                    <Row>
                                        <Col span="24">
                                            {loadingTree ?
                                                <Spin indicator={antIcon} />
                                                : <div id="treeView">
                                                    <Tree
                                                        checkable={nguoiYKienSelected?.key ? true : false}
                                                        checkedKeys={allSelectedKeys || []}
                                                        showIcon
                                                        showLine
                                                        multiple
                                                        switcherIcon={<DownOutlined rev="" />}
                                                        treeData={treeData}
                                                        onCheck={onCheckTree}
                                                        defaultExpandedKeys={[...allSelectedKeys, idQuyDauTu]}
                                                    />
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                </div>
                        }]}>
                    </Tabs>
                </Col>
            </Row>
        </section>
        )
}

export default CauHinhNguoiYKien;